import * as React from "react";
import { useState } from "react";
import SimpleBackdrop from "../../../../../BackDrop/BackDrop";
import MultipleItemCreate from "../../../ActionItems/ActionItemsTableActions/MultipleItemCreate/MultipleItemCreate";

interface Props {
  open: boolean;
  onClose: () => void;
  selectedSiteFloatingAction: any;
  selectedDimensionsFloatingAction: any;
}

export default function MoreAdgroupPopup({
  open,
  onClose,
  selectedSiteFloatingAction,
  selectedDimensionsFloatingAction,
}: Props) {
  const [loading] = useState(false);

  return (
    <React.Fragment>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {open ? (
            <MultipleItemCreate
              open={open}
              handleClose={onClose}
              selectedSiteFloatingAction={selectedSiteFloatingAction}
              selectedDimensionsFloatingAction={
                selectedDimensionsFloatingAction
              }
              trackIdFloatingAction={"434"}
            />
          ) : (
            ""
          )}
        </>
      )}
    </React.Fragment>
  );
}
